import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import "./assets/css/index.scss"
import { OSS_BASE_URL } from './assets/js/aly'
import 'animate.css';
import CountTo from "vue3-count-to";
const app = createApp(App);
app.config.globalProperties.$oss = {
    OSS: OSS_BASE_URL,
};
app.use(store).use(router).use(CountTo).use(ElementPlus, {
  locale: zhCn,
}).mount('#app')
